var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    join = _require$doc$builders.join;

var VariableDeclarationStatement = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    var startsWithVar = node.variables.filter(function (x) {
      return x && x.typeName;
    }).length === 0;
    var doc = join(', ', path.map(function (statementPath) {
      return _print(statementPath);
    }, 'variables'));

    if (node.variables.length > 1 || startsWithVar) {
      doc = concat(['(', doc, ')']);
    }

    if (node.initialValue) {
      doc = concat([doc, ' = ', path.call(_print, 'initialValue')]);
    }

    return concat([startsWithVar ? 'var ' : '', doc, node.omitSemicolon ? '' : ';']);
  }
};
module.exports = VariableDeclarationStatement;